export default __webpack_public_path__ + "locales/fr/Article.json?hash=2603ec5b7acd5593dbd56798f3150bb7";